import actionConstants from '../constants/';

const getImeiDetailState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const imeiBulkUploadHistoryState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: [],
  errorMessage: '',
};

const validateImeiState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: [],
  errorMessage: '',
};

const getEdgeRefFileImeiList = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: [],
  errorMessage: '',
};

const initialState = {
  imeiDetailState: { ...getImeiDetailState },
  imeiBulkUploadHistoryState: { ...imeiBulkUploadHistoryState },
  validateImeiState: { ...validateImeiState },
  getEdgeRefFileImeiList: { ...getEdgeRefFileImeiList },
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function imeiReducer(state = initialState, action) {
  switch (action.type) {
    case actionConstants.GET_IMEI_DETAILS_REQUEST:
      return {
        ...state,
        imeiDetailState: {
          ...state.imeiDetailState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.GET_IMEI_DETAILS_SUCCESS:
      return {
        ...state,
        imeiDetailState: {
          ...state.imeiDetailState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_IMEI_DETAILS_FAILURE:
      return {
        ...state,
        imeiDetailState: {
          ...state.imeiDetailState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action?.payload?.body?.error_code,
          errorMessage: action?.payload?.body?.error_message,
        },
      };

    case actionConstants.GET_IMEI_DETAILS_CLEAR:
      return {
        ...state,
        imeiDetailState: {
          ...initialState.imeiDetailState,
          data: {},
        },
      };

    case actionConstants.GET_REF_FILE_IMEI_LIST_REQUEST:
      return {
        ...state,
        getEdgeRefFileImeiList: {
          ...state.getEdgeRefFileImeiList,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.GET_REF_FILE_IMEI_LIST_SUCCESS:
      return {
        ...state,
        getEdgeRefFileImeiList: {
          ...state.getEdgeRefFileImeiList,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_REF_FILE_IMEI_LIST_FAILURE:
      return {
        ...state,
        getEdgeRefFileImeiList: {
          ...state.getEdgeRefFileImeiList,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_REF_FILE_IMEI_LIST_CLEAR:
      return {
        ...state,
        getEdgeRefFileImeiList: {
          ...initialState.getEdgeRefFileImeiList,
          data: [],
        },
      };

    case actionConstants.GET_IMEI_BULK_UPLOAD_HISTORY_LIST_REQUEST:
      return {
        ...state,
        imeiBulkUploadHistoryState: {
          ...state.imeiBulkUploadHistoryState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.GET_IMEI_BULK_UPLOAD_HISTORY_LIST_SUCCESS:
      return {
        ...state,
        imeiBulkUploadHistoryState: {
          ...state.imeiBulkUploadHistoryState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_IMEI_BULK_UPLOAD_HISTORY_LIST_FAILURE:
      return {
        ...state,
        imeiBulkUploadHistoryState: {
          ...state.imeiBulkUploadHistoryState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action?.payload?.body?.error_code,
          errorMessage: action?.payload?.body?.error_message,
        },
      };

    case actionConstants.GET_IMEI_BULK_UPLOAD_HISTORY_LIST_CLEAR:
      return {
        ...state,
        imeiBulkUploadHistoryState: {
          ...initialState.imeiBulkUploadHistoryState,
          data: [],
        },
      };

    case actionConstants.POST_VALIDATE_IMEI_REQUEST:
      return {
        ...state,
        validateImeiState: {
          ...state.validateImeiState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.POST_VALIDATE_IMEI_SUCCESS:
      return {
        ...state,
        validateImeiState: {
          ...state.validateImeiState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.POST_VALIDATE_IMEI_FAILURE:
      return {
        ...state,
        validateImeiState: {
          ...state.validateImeiState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action?.payload?.body?.error_code,
          errorMessage: action?.payload?.body?.error_message,
        },
      };

    case actionConstants.POST_VALIDATE_IMEI_CLEAR:
      return {
        ...state,
        validateImeiState: {
          ...initialState.validateImeiState,
          data: [],
        },
      };

    default:
      return state;
  }
}
